import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const DashboardCardPC = ({ title, backgroundImageUrl, url }) => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);

    return (
        <div
            className="h-[150px] ms-[25px] mt-[25px] rounded-md overflow-hidden cursor-pointer dashboard-pc-main-card border-white border-[2.35px] relative "
            onClick={() => navigate(url)}
        >
            <img
                src={backgroundImageUrl}
                alt={title}
                onLoad={() => setIsLoading(false)}
                className={`w-full h-full object-cover transition-all duration-500 ${
                    isLoading ? "blur-lg scale-105" : "blur-0 scale-100"
                }`}
            />
            <div className="absolute text-center leading-[30px] w-full bottom-0 left-1/2 translate-x-[-50%] bg-black/60 border-t-[2.35px] border-white flex items-center font-medium text-lg">
                <span className="hvr-sweep-to-right">{title}</span>
            </div>
        </div>
    );
};

export default DashboardCardPC;
